import { render, staticRenderFns } from "./Favicon.vue?vue&type=template&id=529b61dc&"
import script from "./Favicon.vue?vue&type=script&lang=js&"
export * from "./Favicon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports